import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Archive } from "../../../@types/archive";
import api from "../../../utils/api";
import axiosInstance from "../../../utils/axiosConfig";

const updateArchive = createAsyncThunk(
  "documentUpdate/updateArchive",
  async (file: any, { getState, rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post(`${api.baseURL}archive`, formData);
      const data: Archive = response.data;
      return data;
    } catch (error) {

      return rejectWithValue(error);
    }
  }
);

export default updateArchive;
